const _ID = require("util/Id");
const _StringTools = require("util/StringTools");

const Html = {
    insert : function(parentSel, html, resource, addFirst, after){
        let _id = _ID.getID();
        if(!resource)
            resource = {};
        if(!resource._UID_)
            resource._UID_ = _id;
        html = _StringTools.parseHTMLString(html, resource);
        if(after)
            $(parentSel).after(html);
        else if(addFirst)
            $(parentSel).prepend(html);
        else
            $(parentSel).append(html);
        return resource._UID_;
    }
};
module.exports = Html;




// WEBPACK FOOTER //
// ./src/control/util/Html.js